export default "__VITE_ASSET__fgl$WxK0__"